import api, { ApiResponse } from './api'
import type { Merchant } from '../types'

interface UpdateMerchantRequest {
  name?: string
  logo?: string
  website?: string
  description?: string
  phone?: string
  defaultCurrency?: string
  apiIpWhitelist?: string[]
}

interface ApiKeyResponse {
  apiKey: string
}

interface UpdateWebhookResponse {
  webhookSecret: string | null
}

interface OnboardingFeeCheckoutResponse {
  checkoutId: string
  amountUsd: string
  checkoutUrl: string
  expiresAt: number
}

interface MerchantLogoUploadResponse {
  url: string
}

export function getMerchant(): Promise<ApiResponse<Merchant>> {
  return api.get('/v1/merchant/me')
}

export function updateMerchant(data: UpdateMerchantRequest): Promise<ApiResponse<Merchant>> {
  return api.patch('/v1/merchant/me', data)
}

export function uploadMerchantLogo(file: File): Promise<ApiResponse<MerchantLogoUploadResponse>> {
  const formData = new FormData()
  formData.append('file', file)
  return api.post('/v1/merchant/upload/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function updateWebhook(webhookUrl: string, totpCode?: string): Promise<ApiResponse<UpdateWebhookResponse>> {
  return api.patch('/v1/merchant/webhook', { webhookUrl, totpCode })
}

export function regenerateApiKey(totpCode?: string): Promise<ApiResponse<ApiKeyResponse>> {
  return api.post('/v1/merchant/api-key/regenerate', { totpCode })
}

export function regenerateWebhookSecret(totpCode?: string): Promise<ApiResponse<{ secret: string }>> {
  return api.post('/v1/merchant/webhook/regenerate-secret', { totpCode })
}

export function createOnboardingFeeCheckout(data: {
  successUrl: string
  cancelUrl?: string
  preferredPaymentMethod?: string
}): Promise<ApiResponse<OnboardingFeeCheckoutResponse>> {
  return api.post('/v1/merchant/onboarding-fee/checkout', data)
}
